const quadraticEaseInOut = (currentTime, start, change, duration) => {
    currentTime /= duration / 2;
    if (currentTime < 1) {
        return change / 2 * currentTime * currentTime + start;
    }
    currentTime -= 1;
    return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
};

const scrollToSection = (element, change, duration) => {
    const start = window.scrollY || window.pageYOffset;
    let startTime = Date.now();
    let elapsedTime = 0;
    const animateScroll = function() {
        const now = Date.now();
        const timeDelta = +now - +startTime;
        startTime = +now;
        elapsedTime += timeDelta;
        if (elapsedTime > duration) {
            elapsedTime = duration;
        }
        const position = quadraticEaseInOut(elapsedTime, start, change, duration);
        window.scrollTo(0, position);
        if (elapsedTime < duration) {
            window.requestAnimationFrame(animateScroll);
        }
    };
    window.requestAnimationFrame(animateScroll);
};

export {
    quadraticEaseInOut,
    scrollToSection
};
